import { Form as AntForm } from "antd"
import React from "react"
import styled from "styled-components"

import { Required } from "./Required"

export const FormItemBase = React.memo<
  React.ComponentProps<typeof AntForm.Item>
>(function formItem({
  children,
  ...props
}: React.ComponentProps<typeof AntForm.Item>) {
  return <AntForm.Item {...props}>{children}</AntForm.Item>
})
type FormItemIF = {
  children: React.ReactNode
  label?: React.ReactNode
  required?: boolean
} & React.ComponentProps<typeof FormItemBase>

export const FormItem = React.memo<FormItemIF>(function formItem({
  children,
  label,
  required,
  ...props
}: FormItemIF) {
  const labelWithRequired = required ? (
    <>
      <Required />
      {label}
    </>
  ) : (
    label
  )
  return (
    <FormItemBase label={labelWithRequired} {...props}>
      {children}
    </FormItemBase>
  )
})

export const FormItemCenter = styled(FormItem)`
  margin-top: 30px;
  display: block;
  text-align: center;
`
